import {
  Container,
  BackImage,
  Content,
  TitleContainer,
  Title,
  Author,
  Description,
  Text,
  EmbeddedImage,
  Quote,
} from './ArticlePage.styles';
import { UserIcon, TimeIcon } from '@/icons/index';
import dateToString from '@/utils/dateToString';
import { StyledTechDiv } from '../ArticleCard/ArticleCard.styles';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import Tags from '../Tags/Tags';
import WithPagination from '../WithPagination/WithPagination';
import dynamic from 'next/dynamic';

const TrendingJobs = dynamic(() => import(`../TrendingJobs/TrendingJobs`));
const RelatedPosts = dynamic(() => import(`../RelatedPosts/RelatedPosts`));

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: (node: any) => {
      const {
        url,
        fileName,
        details: {
          image: { width, height },
        },
      } = node?.data?.target?.fields?.file;
      return (
        <EmbeddedImage
          loading="lazy"
          src={url}
          alt={fileName + `-icon`}
          width={`100%`}
          height={`${(height / width) * 100}%`}
        />
      );
    },
    [BLOCKS.QUOTE]: (node: any, children: any) => {
      return <Quote>{children}</Quote>;
    },
  },
};

const ArticlePage = ({ article }: any) => {
  const { title, category, author, postDate, description, text } =
    article.fields;

  const richText = documentToReactComponents(text, options);

  return (
    <Container>
      <BackImage />
      <Content>
        <TitleContainer>
          <StyledTechDiv>{category.fields.name}</StyledTechDiv>
          <Title>{title}</Title>
          <Author>
            <p>
              <UserIcon />
              {author}
            </p>
            <p>
              <TimeIcon />
              {dateToString(postDate)}
            </p>
          </Author>
        </TitleContainer>
        <Description>{description}</Description>
        <Text>{richText}</Text>
        <Tags mtags={article.metadata.tags} />
        <WithPagination title="Trending Jobs">
          <TrendingJobs perPage={2} />
        </WithPagination>
        <WithPagination title="Related Posts">
          <RelatedPosts perPage={3} />
        </WithPagination>
      </Content>
    </Container>
  );
};

export default ArticlePage;
